import React from 'react';

import { Badge } from '@mui/material';
import { noop } from 'lodash';
import Button from 'src/components/atoms/button';

import { CartIconStyle } from './style';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { useCartItemCount } from '@hooks/cart/useCartItemCount';

type CartIconProps = {
  onClick?: typeof noop;
};
const CartIcon: React.FC<CartIconProps> = ({ onClick }) => {
  const { itemCount } = useCartItemCount();

  return (
    <CartIconStyle>
      <Button onClick={onClick}>
        <Badge badgeContent={itemCount}>
          <FontAwesomeIcon icon="fa-light fa-cart-shopping" style={{ fontSize: '22px' }} />
        </Badge>
      </Button>
    </CartIconStyle>
  );
};

export default CartIcon;
